import React, { useState, ChangeEvent } from 'react';
import styles from './FileUpload.module.css';
import * as mammoth from 'mammoth';

interface Props {
  onDocTranslateClicked: (text: string) => void;
}

const FileUploadSimple = ({ onDocTranslateClicked }: Props) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    setSelectedFile(file || null);
  };

  const handleConversion = async () => {
    if (!selectedFile) {
      console.log("No file selected");
      return;
    }

    const fileReader = new FileReader();
    fileReader.onload = async () => {
      const fileData = fileReader.result;

      if (selectedFile.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
        const docData = fileData as ArrayBuffer;
        const result = await mammoth.extractRawText({ arrayBuffer: docData });
        const text = result.value;
        console.log('Extracted text from DOCX: ', text);
        onDocTranslateClicked(text);
      } 
      else if (selectedFile.type === "application/pdf") {

        const formData = new FormData();
        formData.append("file", selectedFile);


        const response = await fetch("/api/convert-pdf/", {
            method: "POST",
            body: formData,
            });

        if (!response.ok) {
            console.error("Failed to convert PDF to text");
            return;
        }

        const text = await response.text();
        console.log('Extracted text from PDF: ', text);
        onDocTranslateClicked(text);

        // console.log("PDF conversion not supported yet")
      } 
      else {
        console.log("Unsupported file type");
      }
    };

    if (selectedFile.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || selectedFile.type === "application/pdf") {
      fileReader.readAsArrayBuffer(selectedFile);
    } else {
      console.log("Unsupported file type");
    }
  };

  return (
    <div>
      <input type="file" accept=".docx, .pdf" onChange={handleFileChange} />
      <button className={styles.convertButton} onClick={handleConversion}>Convert to Text</button>
    </div>
  );
};

export default FileUploadSimple;
